<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="800px" class="deliveryAddressDialogBox">
        <div class="deliveryAddressDialog">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="收货人" prop="receiverName">
                    <el-input v-model="form.receiverName" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="form.mobile" placeholder="请输入收货人手机号码"></el-input>
                </el-form-item>
                <el-form-item label="选择地区" prop="storeCity">
                    <el-cascader
                        v-model="form.storeCity"
                        :options="regionOptions"
                        placeholder="省/市/区"
                        style="width: 100%;"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="areaInfo">
                    <el-input v-model="form.areaInfo" placeholder="请输入详细地址"></el-input>
                </el-form-item>
            </el-form>
            <div class="buttonGroup">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import { editAddressInfo,saveAddressInfo } from '../../utils/interface';
    import provinceData from "../../utils/provinceData";
    export default {
        name: "deliveryAddressDialog",
        data(){
            return{
                dialogVisible: false,
                title: '',
                type: '',
                form: {
                    city: '',
                    areaInfo: '',
                    receiverName: '',
                    mobile: '',
                    district: '',
                    province: '',
                    storeCity:'',
                },
                rules: {
                    storeCity: [
                        { required: true, message: '请选择收货地区', trigger: 'change' }
                    ],
                    areaInfo: [
                        { required: true, message: '请输入详细地址', trigger: 'blur' }
                    ],
                    receiverName: [
                        { required: true, message: '请输入收货人姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, validator: this.validatorPhone, trigger: 'blur' }
                    ]
                },
                regionOptions: provinceData,
            }
        },
        methods: {
            init(type,val){
                this.reset();
                this.type = type;
                if(type === 'add'){
                    this.title = '新增收货地址';
                } else {
                    this.title = '编辑收货地址';
                    this.form = val;
                    let arr = new Array();
                    if(this.form.province!=''&&this.form.province!=this.form.city){
                        arr.push(this.form.province.replace('省',''));
                    }else if(this.form.province!=''&&this.form.province==this.form.city){
                        arr.push(this.form.province.replace('市',''));
                    }
                    if(this.form.city!=''&&this.form.province!=this.form.city){
                        arr.push(this.form.city.replace('市',''));
                    }
                    if(this.form.district!=''){
                        arr.push(this.form.district);
                    }
                    this.form.storeCity = arr;
                }
                this.dialogVisible = true;
            },
            // 地址保存
            submitForm(){
                if(this.form.storeCity != null && this.form.storeCity.length == 3){
                    this.form.province = this.form.storeCity[0]+"省";
                    this.form.city = this.form.storeCity[1]+"市";
                    this.form.district = this.form.storeCity[2];
                } else if(this.form.storeCity != null && this.form.storeCity.length == 2){
                    this.form.province = this.form.storeCity[0]+"市";
                    this.form.city = this.form.storeCity[0]+"市";
                    this.form.district = this.form.storeCity[1];
                }
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.form.uuid != null){
                            editAddressInfo(this.form).then((res)=>{
                                this.$message.success('修改成功！');
                                this.dialogVisible = false;
                                this.$emit('address',this.form);
                            });
                        }else{
                            saveAddressInfo(this.form).then((res)=>{
                                this.$message.success('保存成功！');
                                this.dialogVisible = false;
                                this.$emit('address',this.form);
                            });
                        }
                    } else {
                        return false;
                    }
                })
            },
            // 联系方式校验
            validatorPhone(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入收货人手机号码'))
                } else if (!this.validate.isMobile(value)) {
                    callback(new Error('请输入正确的手机号码'))
                } else {
                    callback()
                }
            },
            // 邮箱地址校验
            validatorEmail(rule, value, callback){
                if (value === '') {
                    callback()
                } else if (!this.validate.isEmail(value)) {
                    callback(new Error('请输入正确的邮箱地址'))
                } else {
                    callback()
                }
            },
            // 表单重置
            reset(){
                this.form = {
                    city: '',
                    areaInfo: '',
                    receiverName: '',
                    mobile: '',
                    district: '',
                    province: '',
                    storeCity:'',
                }
            }
        }
    }
</script>

<style scoped lang="less">
    div{
        box-sizing: border-box;
    }
    .deliveryAddressDialogBox {
        /deep/.el-dialog__body {
            padding: 0;
        }
        .deliveryAddressDialog {
            .demo-ruleForm {
                padding: 30px 80px 30px 50px;
            }
            .buttonGroup{
                text-align: right;
                width: 100%;
                padding: 6px 24px;
                border-top: 1px solid #ddd;
                /deep/.el-button{
                    padding: 10px 25px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/deliveryAddressDialog.vue